import { RouterLink } from 'vue-router';


const state = {
  userData: {}, //用户登录信息
  loginShowFlag: false,
  isLoginFlag: false,
  updateInfoFlag: false,//修改个人信息
  updateScoreFlag: false,//修改成绩
  openVipVisible: false,//开通vip
  token: "",
  studentData: {}
};

const mutations = {
  UPDATE_USERDATA(state, obj) {
    state.userData = obj;
  },
  UPDATE_LOGINSHOWFLAG(state, flag) {
    state.loginShowFlag = flag;
  },
  UPDATE_TOKEN(state, token) {
    state.token = token;
  },
  UPDATE_STUDENT(state, studentData) {
    state.studentData = studentData;
  },
  UPDATE_UPDATEINFOFLAG(state, flag) {
    state.updateInfoFlag = flag;
  },
  UPDATE_UPDATESCOREFLAG(state, flag) {
    state.updateScoreFlag = flag;
  },
  UPDATE_openVipVisible(state, flag) {
    state.openVipVisible = flag;
  },
  UPDATE_ISLOGINFLAG(state, flag) {
    state.isLoginFlag = flag;
  },
};
const actions = {
};

export default {
  state,
  mutations,
  actions
};

